import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Approach from './components/Approach';
import Capabilities from './components/Capabilities';
import WhoWeWorkWith from './components/WhoWeWorkWith';
import HowWeWork from './components/HowWeWork';
import TechnologyIntelligence from './components/TechnologyIntelligence';
import Impact from './components/Impact';
import Insights from './components/Insights';
import About from './components/About';
import Partners from './components/Partners';
import OurWorks from './components/OurWorks';
import Contact from './components/Contact';
import Footer from './components/Footer';

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <Navbar />
      <Hero />
      <Approach />
      <Capabilities />
      <WhoWeWorkWith />
      <HowWeWork />
      <TechnologyIntelligence />
      <Impact />
      <Insights />
      <About />
      <Partners />
      <OurWorks />
      <Contact />
      <Footer />
    </main>
  );
}